import DOMPurify from 'dompurify';

// Función para convertir HTML a texto plano
export const htmlToPlainText = (html) => {
  if (!html) return '';
  
  // Si no contiene tags HTML, devolver tal cual
  if (!html.includes('<')) return html;
  
  // Crear un elemento temporal para parsear el HTML (sanitizado)
  const temp = document.createElement('div');
  temp.innerHTML = DOMPurify.sanitize(html);
  
  // Función recursiva para procesar nodos
  const processNode = (node) => {
    let result = '';
    
    node.childNodes.forEach(child => {
      if (child.nodeType === Node.TEXT_NODE) {
        result += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tagName = child.tagName.toLowerCase();
        
        switch(tagName) {
          case 'p':
            result += processNode(child) + '\n';
            break;
          case 'br':
            result += '\n';
            break;
          case 'li':
            result += '• ' + processNode(child) + '\n';
            break;
          case 'ul':
          case 'ol':
            result += processNode(child);
            break;
          case 'h1':
          case 'h2':
          case 'h3':
            result += processNode(child) + '\n';
            break;
          case 'blockquote':
            result += '"' + processNode(child) + '"\n';
            break;
          case 'a':
            const text = processNode(child);
            const href = child.getAttribute('href');
            result += href && href !== text ? `${text} (${href})` : text;
            break;
          default:
            result += processNode(child);
        }
      }
    });
    
    return result;
  };
  
  return processNode(temp).trim();
};

export default htmlToPlainText;
